const Map = () => {
    return (
        // <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387194.0622843894!2d-74.30932844391303!3d40.69701928424492!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1683361997895!5m2!1sen!2sbd"></iframe>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12870.522164944296!2d139.7795314!3d36.2484679!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601f4c7a451fb377%3A0xade6d6f8796b2379!2sKaga%20Motors!5e0!3m2!1sen!2slk!4v1690652508936!5m2!1sen!2slk" width="600" height="450" style={{"border":"0"}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
    );
};

export default Map;
